<template>
  <div class="container" style="height: calc(100% - 155px)">
    <div style="width: 1260px; margin: 0 auto; display: flex; height: 100%">
      <div class="tab">
        <div class="tab_title">下载</div>
      </div>
      <div class="content" style="height: calc(100% - 90px)">
        <div>
            <div class="dl_box" v-for="(item,index) in download_list" :key="index">
                <div class="boxsym" :style="{ background: 'url(' + item.img + ') no-repeat center',}"></div>
                <div class="mes_box">
                    <div class="box_top">
                        <div class="software">
                            <div class="software-name">{{item.name}}</div>
                            <div class="rj_dl" @click="xgdownload(item.download)">点击下载</div>
                        </div>
                    </div>
                    <div class="rj_bb">{{item.bb}}</div>
                    <div class="rj_js" v-if="typeof(item.js)=='string'">{{item.js}}</div>
                    <div class="rj_js" v-else>
                        <div v-for="(item1,index1) in item.js" :key="index1">
                            {{item1}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {jsonp} from 'vue-jsonp'
import commonData from '../plugins/FetchCommonData'
export default {
data () {
    return {
        download_list:[
            {
                img:require("../assets/img/T8_logo.png"),
                name:'',
                bb:'加载中...',
                js:'资金管理层面的专业视角，积木式编程语言、期货化的回测工具、列表式运行管理界面，支持投资组合配置、运行收益分析、单元头寸管理、风险控制...',
                download:'',
                jsonp:''
            },
            {
                img:require("../assets/img/T9_logo.png"),
                name:'',
                bb:'加载中...',
                js:'针对机构和量化团队，聚焦盘口算法模型开发、回测和自动交易，支持期货、期权的各种复杂交易，也支持算法组件附加到手动交易、趋势量化策略的执行过程中，进行精细化控制，根据盘口行情智能拆单，降低冲击成本，提高交易效率。',
                download:'',
            },
            {
                img:require("../assets/img/T10_logo.png"),
                name:'',
                bb:'加载中...',
                js:[],
                download:'',
            },
            {
                img:require("../assets/img/wh11_logo.png"),
                name:'',
                bb:'加载中...',
                js:[],
                download:'',
            },
        ]
    }
},
created(){
    this.setCommonData()
    jsonp("https://db.wenhua.com.cn/inc/update.asp", {
      appid: 11,
      t: 0,
    },60000)
      .then((data) => {
        this.download_list[0].jsonp = data;
        this.download_list[0].download= "//ftpc.wenhua.com.cn/files/WT8_setup_" +data.split("|")[0] +".exe";
        this.download_list[0].bb =
          "  版本:" +
          data.split("|")[0] +
          ""  +
          "\xa0\xa0" +
          " 大小:" +
          data.split("|")[2] +
          "\xa0\xa0" +
          " 日期:" +
          data.split("|")[1];
      })
      .catch((err) => {
        console.log(err);
      });
      axios({
        url:'https://wt9.wenhua.com.cn/api/DownloadApi/GetAppUpdateList',
        method:'get',
      }).then((res)=>{
         if(res.data.status){
            this.download_list[1].download="//ftpc.wenhua.com.cn/files/WT9_setup_" + res.data.data[0].Version + ".exe";
            this.download_list[1].bb= "  版本:" +res.data.data[0].Version +""  +"\xa0\xa0" +" 大小:" +res.data.data[0].SoftSize +"\xa0\xa0" +" 日期:" +res.data.data[0].UpdateDate;
         }
      })
       axios({
        url:'https://webapi.wenhua.com.cn/update/api/Update/GetUpdateInfo',
        method:'get',
        params:{
            appid:37
        }
      }).then((res)=>{
         if(res.data.Status){
            var data=JSON.parse(res.data.ResultData)
            this.download_list[2].download='https://ftpc.wenhua.com.cn/files/wh11_setup_'+data.Version+'.exe';
            this.download_list[2].bb= "  版本:" +data.Version +""  +"\xa0\xa0" +" 大小:" +data.Size +"\xa0\xa0" +" 日期:" +data.UpdateTime;
         }
      })
             axios({
        url:'https://webapi.wenhua.com.cn/update/api/Update/GetUpdateInfo',
        method:'get',
        params:{
            appid:29
        }
      }).then((res)=>{
         if(res.data.Status){
            var data=JSON.parse(res.data.ResultData)
            this.download_list[3].download="https://ftpc.wenhua.com.cn/files/wh12_setup_"+data.Version+".exe";
            this.download_list[3].bb= "  版本:" +data.Version +""  +"\xa0\xa0" +" 大小:" +data.Size +"\xa0\xa0" +" 日期:" +data.UpdateTime;
         }
      })
      
},
methods:{
    async setCommonData(){
        this.download_list[0].name = await commonData('appFullName_11');
        this.download_list[1].name = await commonData('appFullName_17');
        this.download_list[2].name = await commonData('appFullName_37');
        this.download_list[2].js[0] = '为多因子估值数据库的量化应用示范平台，支持量化多头策略、市场中性策略、可转债策略的研发，提供了包括编写因子、可视化策略构建、回测报告、收益归因分析等功能。';
        this.download_list[2].js[1] = '另外，' + await commonData('appShortName_37') + '提供实用性的股票投资策略案例。';
        this.download_list[3].name = await commonData('appFullName_29');
        this.download_list[3].js[0] = '股票投资方面，作为多因子估值数据库的量化应用示范平台，支持引用估值数据，以及宏观、市场情绪、财务等各类事件因子，来开发风险控制策略，提供了包括编写因子、可视化策略构建、回测报告等功能。另外，' + await commonData('appShortName_29') + '提供实用性的风险控制策略案例。';
        this.download_list[3].js[1] = '商品CTA方面，支持引用大宗商品的产业大数据，宏观、供给、需求、消费等因子，量化各类市场参与者的决策依据，仿真市场价格的形成机制，对各个商品做多因子分析，构建量化交易策略。';
        this.download_list[3].js[2] = await commonData('appShortName_29') + '也内置了文华的AI大语言模型技术，引用文华财经的行业新闻数据库，AI技术做行情分析，撰写研究报告。'
    },
    xgdownload(url){
        window.location.href=url
    }
}
}
</script>

<style scoped>
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82)no-repeat top,url(../assets/img/bgonepp.jpg)repeat-y center top 900px;
  text-align: left;
}
.tab {
  visibility: hidden;
  flex-grow: 1;
}
.content {
  width: 1020px;
  color: rgb(132, 133, 135);
  height: 100%;
  min-height: 600px;
  background: url(../assets/img/download_bg.png)no-repeat center;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  padding: 40px 0;
  font-size: 16px;
  border-radius: 10px  10px 0 0;
  padding-top: 70px;
}

.dl_box {
    margin: 0 auto;
    width: 810px;
    margin-bottom: 40px;
    position: relative;
    padding-bottom: 20px;
}
.boxsym {
    z-index: 2;
    /* position: absolute; */
    height: 132px;
    width: 124px;
    display: inline-block;
    vertical-align: middle;
}
.mes_box {
    width: 640px;
    z-index: 0;
    display: inline-block;
    overflow: hidden;
    text-align: justify;
    padding: 0px 0 10px 40px;
    vertical-align: middle;
}
.software {
    height: 35px;
    display: flex;
    align-items: center;
}
.software-name {
    font-size: 20px;
    color: #464f5c;
    font-family: " SourceHanSansCN";
    width: 185px;
}
.rj_dl {
    text-align: center;
    font-size: 12px;
    border-bottom: 1px solid #3988ff;
    padding: 1px 0;
    color: #3988ff;
    margin-left: 60px;
    text-decoration: none !important;
    cursor: pointer;
}
.rj_bb {
    font-size: 12px;
    color: #5d697a;
    opacity: 0.6;
    line-height: 24px;
}
.rj_js {
    font-size: 14px;
    line-height: 19px;
    line-height: 20px;
    /* color: #5d697a; */
    color: #777775;
    /* opacity: 0.8; */
    margin-top: 10px;
}
</style>